






























import { EventJson } from '@ssp/inscreva-sse-models';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import EventFilter from '@/components/EventFilter.vue';
import EventList from '@/components/EventList.vue';
import toast from '@/components/toast';
import { ToastType } from '@/components/toast/tost-type.enum';
import { Event } from '@/models/event';
import { eventStore } from '@/store/event';

import { sessionStore } from '../store/session';
import config from '../utils/config';

@Component({
  components: {
    Loading,
    EventFilter,
    EventList,
  },
})
export default class EventsPage extends Vue {
  private isLoading: boolean = null;

  private events: Array<Event> = [];

  filteredEvents: Array<Event> = this.events;

  onFilteredEvents(filteredEvents: Array<Event>) {
    this.filteredEvents = [];
    setTimeout(() => {
      this.filteredEvents = filteredEvents;
    }, 100);
  }

  async created() {
    await this.fetch();
  }

  async fetch() {
    try {
      this.isLoading = true;
      this.events = (await eventStore.list()).sort(
        ({ createdAt: createdAtA }, { createdAt: createdAtB }) =>
          new Date(createdAtB || null).getTime() - new Date(createdAtA || null).getTime(),
      );
    } catch (err) {
      toast('Erro ao carregar dados', ToastType.ERROR);
    }
    this.isLoading = false;
  }

  get selectedEvent(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  async onSelectEvent(event: Event) {
    sessionStore.select(Object.assign(sessionStore.session, { event }));
    if (this.$route.path !== '/subscriptions') {
      await this.$router.replace({ path: '/subscriptions', replace: true, append: false });
    }
    window.location.reload();
  }

  onEditEvent(event: Event) {
    this.$router.push({ path: `/event/${event._id}`, append: false });
  }

  onVisualizeEvent(event: Event) {
    window.open(`${config.getFrontAddress()}/${event.alias}`);
  }

  async onActiveStatusChange(event: Event) {
    event.active = !event.active;
    const operation: 'inativar' | 'ativar' = event.active === false ? 'inativar' : 'ativar';
    await eventStore
      .update(event)
      .then(() => toast(`Sucesso ao ${operation} evento`, operation === 'ativar' ? ToastType.SUCESS : ToastType.INFO))
      .catch(() => toast(`Falha ao ${operation} evento`, ToastType.ERROR));
  }
}
